import { render, staticRenderFns } from "./kicon.vue?vue&type=template&id=3a70fc86&scoped=true"
import script from "./kicon.vue?vue&type=script&lang=js"
export * from "./kicon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a70fc86",
  null
  
)

export default component.exports